module.exports = __webpack_public_path__ + "static/media/so.a3c1b750.svg";